module.exports = __webpack_public_path__ + "img/universe-sheets.6a1920e0.png";